import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import {
  useFetchAuthorisation,
  authorisationConverter,
  useFetchUserData,
} from "../../utils/AppFunctions";
import config from "../../app-config";
import "react-toastify/dist/ReactToastify.css";
import AdminLayout from "../../layouts/AdminLayout";
import { captialise_first_letter, tidy_date } from "../../utils/helper";
import notify from "../../utils/IANotification";
import Table from "../../components/app-components/Table";
import DataTable from "../../components/ui/DataTable";
import Button from "../../components/ui/Button";
import { MdAutorenew, MdCheck, MdPerson } from "react-icons/md";

export default function LibraryLoanRecordsPage() {
  const navigate = useNavigate();
  const { isAuthorised, userRole } = useFetchAuthorisation("user");
  let user_data = useFetchUserData();

  const [recordsData, setRecordsData] = useState([]);
  const [query, setQuery] = useState("")

  useEffect(() => {
    fetchLoanRecords();
  }, []);

  const fetchLoanRecords = async () => {
    let endpoint = `${config.endpoint}/library/records`;
    let fetchResponse = await fetch(endpoint, {
      method: "GET",
      credentials: "include"
    })
    let data = await fetchResponse.json()
    if (data.status === 200) {
      setRecordsData(data.data?.reverse())
    } else {
      notify({ message: data.message, type: "error" })
    }
  }


  const returnItem = async (record_id) => {
    let endpoint = `${config.endpoint}/library/admin/return`
    let fetchResponse = await fetch(endpoint, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ record_id, })
    })
    let data = await fetchResponse.json()
    if (data.status === 200) {
      notify({ message: data.message, type: "success" })
      fetchLoanRecords()
    } else {
      notify({ message: data.message, type: "error" })
    }
  }


  const renewItem = async (record_id) => {
    let endpoint = `${config.endpoint}/library/admin/renew`
    let fetchResponse = await fetch(endpoint, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ record_id, })
    })
    let data = await fetchResponse.json()
    if (data.status === 200) {
      notify({ message: data.message, type: "success" })
      fetchLoanRecords()
    } else {
      notify({ message: data.message, type: "error" })
    }
  }


  let table_columns = [
    {
      header: "Name",
      accessor: "user_data",
      modifier: (value, row) => `${row?.user_data?.first_name} ${row?.user_data?.last_name}`
    },
    {
      header: "Email",
      accessor: "user_data.email",
    },
    {
      header: "Item",
      accessor: "library_item_data.title",
    },
    {
      header: "Status",
      accessor: "is_returned",
      modifier: (value, row) => row?.is_returned == 1 ? "Returned" : `On loan till ${tidy_date(row?.return_date)}`
    },

  ]

  return (
    <AdminLayout navSelected={"Borrowed Items"}
      toolbar={
        <>
          <h1 className="text-2xl font-bold text-gray-900">Loan Records</h1>
        </>
      }
    >

      {/* <div className="column items-center justify-between w-100 mb-4">
        <input
          type="text"
          placeholder="Search..."
          className='text-input w-100'
          value={query}
          onChange={(e) => {
            setQuery(e.target.value)
          }}
        />
      </div> */}

      {/* <Table
        columns={table_columns}
        data={recordsData?.map((record) => {
          if (query && !JSON.stringify(record).toLowerCase().includes(query.toLowerCase())) return {}
          return record
        })?.filter((record) => Object.keys(record).length > 0)}
        actions={(row) => {
          return (
            <>
              <div className="flex flex-row items-center gap-2">
                {row?.is_returned == 0 && <button className="text-xs hover:underline" onClick={() => {
                  returnItem(row.id)
                }}>Return</button>}
                {row?.is_returned == 0 && <button className="text-xs hover:underline" onClick={() => {
                  renewItem(row.id)
                }}>Renew</button>}
                <button className="text-xs hover:underline" onClick={() => {
                  navigate("/admin/users/details?user_id=" + row.user_id, { replace: false })
                }}>View User</button>
              </div>
            </>
          )
        }}
      /> */}

      <DataTable
        columns={table_columns}
        data={recordsData}
        enableActions
        actions={(row) => {
          return (
            <div className="flex gap-2">
              {row?.is_returned == 0 && (
                <Button variant="outline" size="sm" icon={MdCheck} onClick={() => returnItem(row.id)}>
                  Return
                </Button>
              )}
              {row?.is_returned == 0 && (
                <Button variant="outline" size="sm" icon={MdAutorenew} onClick={() => renewItem(row.id)}>
                  Renew
                </Button>
              )}
              <Button variant="outline" size="sm" icon={MdPerson} onClick={() => navigate("/admin/users/details?user_id=" + row.user_id, { replace: false })}>
                View User
              </Button>
            </div>
          )
        }}
      />
    </AdminLayout>
  )
}